import { Badge, Button, message } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { getSelector } from "../../redux/models/baseModel/baseModel";
import VideoArchive from "../../redux/models/videoArchive/videoArchive";
import { programaticDownload } from "../../utilities/generalUtility";
import { getActualPath } from "../common/formItems/CustomImageUpload";

const VideoDownloadSelected = () => {
  const urlForDownload = useSelector((state) =>
    getSelector(VideoArchive)(state)
      .filter((el) => el.isSelected)
      .map((el) => el.response.videoUrl)
  );
  const videoDownloadLink = getActualPath("/responses/get-archive?fileNames=" + JSON.stringify(urlForDownload));

  // http://ahsan1.localhost:8088/api/responses/get-archive?fileNames=["6/question15/1d4c938d-541a-47af-b2b2-c59ae45e4d99.mp4","6/question15/922863f0-3b20-4a90-8354-00908c0e135f.mp4"]

  const onDownload = () => {
    if (urlForDownload.length < 1) {
      message.error("Select videos before downloading!");
    } else {
      VideoArchive.downloadVideo(videoDownloadLink)
        .then((res) => {
          programaticDownload(res);
        })
        .catch((err) => {
          console.error(err);
          message.error("Failed to download video.");
        });
    }
  };
  const handleClick = () => {
    if (urlForDownload.length < 1) {
      message.error("Select videos before downloading!");
    } else {
      window.location.href = videoDownloadLink;
    }
  };

  return (
    <Badge count={urlForDownload.length}>
      <Button type="primary" ghost onClick={handleClick}>
        Download Selected
      </Button>
    </Badge>
  );
};

export default VideoDownloadSelected;
